import { useQuery } from '@tanstack/react-query';
import { getAuthorizationCredentialsQueryKey } from '../factories/queries';
import { CredentialsService } from '../services';
import type { IAuthorization } from '../types';

export const useGetAuthorizationCredentials = (
  professionalId: string,
  enabled: boolean = true,
) => {
  const { data, isLoading, isError, error } = useQuery<IAuthorization[], Error>({
    queryKey: getAuthorizationCredentialsQueryKey(professionalId),
    queryFn: () => CredentialsService.getAuthorizationCredentials(professionalId),
    enabled: !!professionalId && enabled,
    retry: false,
  });

  const authorizations = data ?? [];

  return {
    authorizations,
    isLoading,
    isError,
    error,
  };
};
